export default __webpack_public_path__ + "static/media/11.a2163c65.jpg";